import * as Types from '../../../../../../graphql/src/lib/types';

import { InferenceStream } from '@wm-front/core'
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AdminInfoQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdminInfoQueryQuery = { __typename?: 'Query', me: { __typename?: 'Admin', territories: Array<{ __typename?: 'Territory', countryCode: string, name: string }>, subscriptionInfo: { __typename?: 'SubscriptionInfo', id: string, hmac: string } } | { __typename?: 'Customer' } | { __typename?: 'Mechanic' } };

export const AdminInfoQueryDocument = gql`
    query AdminInfoQuery {
  me {
    ... on Admin {
      territories {
        countryCode
        name
      }
      subscriptionInfo {
        id
        hmac
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdminInfoQueryGQL extends Apollo.Query<AdminInfoQueryQuery, AdminInfoQueryQueryVariables> {
    override document = AdminInfoQueryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }